// extracted by mini-css-extract-plugin
export default {"inline":"pageTurning_inline__lCj-Q","width-50":"pageTurning_width-50__NtFEK","pageStyle":"pageTurning_pageStyle__qoj+e"};